/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Score_StrongInputs */

const en_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong ATS compatibility`)
};

const de_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starke ATS-Kompatibilität`)
};

const fr_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forte compatibilité ATS`)
};

const es_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerte compatibilidad ATS`)
};

const it_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forte compatibilità ATS`)
};

const nl_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sterke ATS-compatibiliteit`)
};

const pl_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silna kompatybilność z ATS`)
};

const fi_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahva ATS-yhteensopivuus`)
};

const da_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stærk ATS-kompatibilitet`)
};

const sv_ats_score_strong = /** @type {(inputs: Ats_Score_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stark ATS-kompatibilitet`)
};

/**
* | output |
* | --- |
* | "Strong ATS compatibility" |
*
* @param {Ats_Score_StrongInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_score_strong = /** @type {((inputs?: Ats_Score_StrongInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Score_StrongInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_score_strong(inputs)
	if (locale === "fr") return fr_ats_score_strong(inputs)
	if (locale === "es") return es_ats_score_strong(inputs)
	if (locale === "it") return it_ats_score_strong(inputs)
	if (locale === "nl") return nl_ats_score_strong(inputs)
	if (locale === "pl") return pl_ats_score_strong(inputs)
	if (locale === "fi") return fi_ats_score_strong(inputs)
	if (locale === "da") return da_ats_score_strong(inputs)
	if (locale === "sv") return sv_ats_score_strong(inputs)
	return en_ats_score_strong(inputs)
});